import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"position":"relative"},
  class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6"
}
const _hoisted_2 = { class: "text-red-500 fa-solid fa-circle-xmark" }
const _hoisted_3 = { class: "text-green-500 fa-solid fa-circle-check" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[1] || (_cache[1] = _createTextVNode(" Is Acumatica authorized?: ")),
      _withDirectives(_createElementVNode("i", _hoisted_2, null, 512 /* NEED_PATCH */), [
        [_vShow, !$setup.com_is_acumatica_authed]
      ]),
      _withDirectives(_createElementVNode("i", _hoisted_3, null, 512 /* NEED_PATCH */), [
        [_vShow, $setup.com_is_acumatica_authed]
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_basic_button, {
        onClick: _cache[0] || (_cache[0] = $event => ($setup.start_acumatica_auth())),
        size: $setup.Size.normal,
        class: "ml-5 mr-5"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1 /* CACHED */),
          _createTextVNode(" Renew Acumatica Authorization ")
        ])),
        _: 1 /* STABLE */,
        __: [2]
      }, 8 /* PROPS */, ["size"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("small", null, "Projects Sync Last Attempted At: " + _toDisplayString($setup.com_projects_sync_attempted_at), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("small", null, "Projects Sync Last Succeeded At: " + _toDisplayString($setup.com_projects_sync_succeeded_at), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("small", null, "Purchase Orders Sync Last Succeeded At: " + _toDisplayString($setup.com_purchase_orders_sync_attempted_at), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("small", null, "Purchase Orders Sync Last Attempted At: " + _toDisplayString($setup.com_purchase_orders_sync_succeeded_at), 1 /* TEXT */)
    ])
  ]))
}